<template>
    <div class="user-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="用户名">
                <el-input size="small" v-model="dataForm.loginName" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input size="small" v-model="dataForm.realName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
                <el-input size="small" v-model="dataForm.mail" placeholder="邮箱" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" size="small" class="cla-user-search" @click="queryHandle()">查询
                </el-button>
                <el-button size="small" class="cla-user-add" type="primary" @click="addOrUpdateHandle()"
                           icon="el-icon-plus">新建
                </el-button>
            </el-form-item>
            <el-row style="margin-top: -10px;">
                <el-form-item>

                    <el-button icon="el-icon-user" size="small" class="cla-user-add" :disabled="dataListSelections.length <= 0"
                               type="success"
                               @click="assignRoleHandle()">
                        分配角色
                    </el-button>
                    <el-button icon="el-icon-monitor" size="small" class="cla-user-add" :disabled="dataListSelections.length <= 0"
                               type="success"
                               @click="assignPositionHandle()">
                        设置岗位
                    </el-button>
                    <el-button icon="el-icon-menu" size="small" class="cla-user-add" :disabled="dataListSelections.length <= 0"
                               type="success"
                               @click="assignOrgHandle()">
                        关联组织
                    </el-button>
                    <el-button icon="el-icon-delete" size="small" type="danger" @click="deleteHandle()"
                               :disabled="dataListSelections.length <= 0">
                        批量删除
                    </el-button>
                </el-form-item>
            </el-row>

        </el-form>
        <el-table :data="dataList" size="small" v-loading="dataListLoading" @sort-change="sortChangeHandle"
                  @selection-change="selectionChangeHandle" :height=documentClientHeight style="width: 100%;">
            <el-table-column type="selection" header-align="left" align="left" width="50">
            </el-table-column>
            <el-table-column prop="loginName" header-align="left" align="left" min-width="100" label="用户名">
            </el-table-column>
            <el-table-column prop="realName" header-align="left" align="left" min-width="100" label="姓名" sortable="custom">
                <template slot-scope="scope">
                    <el-link type="primary" @click="showDrawerHandle(scope.row.id)">{{scope.row.realName}}</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="roleList" header-align="left" align="left" min-width="100" label="角色"
                             class-name="col-popover-tip">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p :key="item.id" v-for="item in scope.row.roleList">
                            <el-tag size="small" type="info">{{item.roleName}}</el-tag>
                        </p>
                        <div slot="reference" class="name-wrapper">
                            <el-tag size="small" :key="item.id" v-for="item in scope.row.roleList" type="info">
                                {{item.roleName}}
                            </el-tag>
                        </div>
                    </el-popover>
                    <!--<el-tag v-else size="small" :key="item.id" v-for="item in scope.row.roleList" type="info">-->
                        <!--{{item.roleName}}-->
                    <!--</el-tag>-->
                </template>
            </el-table-column>
            <el-table-column prop="positionName" header-align="left" align="left" min-width="100" label="岗位" class-name="col-popover-tip">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p :key="item.id" v-for="item in scope.row.positionList">
                            <el-tag size="small" type="info">{{item.positionName}}</el-tag>
                        </p>
                        <div slot="reference" class="name-wrapper">
                            <el-tag size="small" :key="item.id" v-for="item in scope.row.positionList" type="info">
                                {{item.positionName}}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="orgList" header-align="left" align="left" min-width="150" label="组织">
                <template slot-scope="scope">
                    <p class="table-cell-p" :key="item.id" v-for="item in scope.row.orgList">
                        {{item.orgName}}
                    </p>
                </template>
            </el-table-column>
            <!--<el-table-column prop="mainBodyList" header-align="left" align="left" min-width="150" label="主体">-->
                <!--<template slot-scope="scope">-->
                    <!--<p class="table-cell-p" :key="item.id" v-for="item in scope.row.mainBodyList">-->
                        <!--{{item.mainBodyName}}-->
                    <!--</p>-->
                <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="tenantName" header-align="left" align="left" min-width="150" label="租户">-->
            <!--</el-table-column>-->
            <el-table-column prop="mail" header-align="left" align="left" min-width="200" label="邮箱">
            </el-table-column>
            <el-table-column prop="mobile" header-align="left" align="left" min-width="120" label="手机号">
            </el-table-column>
            <el-table-column prop="userStatus" header-align="center" align="center" width="80" label="状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.userStatus === 2" size="small" type="danger">禁用</el-tag>
                    <el-tag v-else size="small">正常</el-tag>
                </template>
            </el-table-column>
            <el-table-column fixed="right" header-align="center" align="center" width="200" label="操作">
                <template slot-scope="scope">
                    <el-button icon="el-icon-lock" size="small" type="text"
                               @click="initPasswordHandle(scope.row.id)">
                        重置密码
                    </el-button>
                    <el-button icon="el-icon-edit" type="text" size="small"
                               @click="addOrUpdateHandle(scope.row.id)">修改
                    </el-button>
                    <el-button icon="el-icon-delete" type="text" size="small"
                               @click="deleteHandle(scope.row.id)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <drawer-info v-if="drawerInfoVisible" ref="drawerInfo" @refreshDataList="getDataList"></drawer-info>
        <assign-role-info v-if="assignRoleInfoVisible" ref="assignRoleInfo"
                          @refreshDataList="getDataList"></assign-role-info>
        <assign-position-info v-if="assignPositionInfoVisible" ref="assignPositionInfo"
                              @refreshDataList="getDataList"></assign-position-info>
        <assign-org-info v-if="assignOrgInfoVisible" ref="assignOrgInfo"
                         @refreshDataList="getDataList"></assign-org-info>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="temp" :rules="dataRule" ref="temp" @keyup.enter.native="dataFormSubmit()"
                     label-width="80px" class="password-dialog-form">
                <el-form-item label="密码" prop="newPassword">
                    <el-input type="password" v-model="temp.newPassword"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input type="password" v-model="temp.confirmPassword"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import {fetchUserList, updatePassword, deleteUser} from '@/controller/sys'
    import AddOrUpdate from './user-add-or-update'
    import AssignRoleInfo from './assign-role-info'
    import AssignPositionInfo from './assign-position-info'
    import AssignOrgInfo from './assign-org-info'
    import DrawerInfo from './drawer-info'

    export default {
        data() {
            let validateConfirmPassword = (rule, value, callback) => {
                if (this.temp.newPassword !== value) {
                    callback(new Error('确认密码与新密码不一致'))
                } else {
                    callback()
                }
            }
            return {
                userId: 0,
                dialogFormVisible: false,
                documentClientHeight: document.documentElement['clientHeight'] - 260,
                dataForm: {
                    loginName: '',
                    realName: '',
                    newPassword: '',
                    confirmPassword: '',
                    mail:'',
                },
                temp: {
                    newPassword: '',
                    confirmPassword: ''
                },
                dataRule: {
                    password: [{
                        required: true,
                        message: '原密码不能为空',
                        trigger: 'blur'
                    }],
                    newPassword: [{
                        required: true,
                        message: '新密码不能为空',
                        trigger: 'blur'
                    }, {
                        min: 5,
                        max: 25,
                        message: '长度在 5 到 25个字符'
                    },
                        {
                            pattern: /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]+$/,
                            message: '密码必须为数字，字母，特殊字符三种的组合'
                        }
                    ],
                    confirmPassword: [{
                        required: true,
                        message: '确认密码不能为空',
                        trigger: 'blur'
                    },
                        {
                            validator: validateConfirmPassword,
                            trigger: 'blur'
                        }
                    ]
                },
                dataList: [],
                userTypeList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                assignRoleInfoVisible: false,
                addOrUpdateVisible: false,
                assignPositionInfoVisible: false,
                assignOrgInfoVisible: false,
                drawerInfoVisible: false
            }
        },
        components: {
            AddOrUpdate,
            AssignRoleInfo,
            AssignPositionInfo,
            AssignOrgInfo,
            DrawerInfo
        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                fetchUserList(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'loginName': this.dataForm.loginName,
                        'mail': this.dataForm.mail,
                        'realName': this.dataForm.realName,
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            showDrawerHandle(id){
                this.drawerInfoVisible = true
                this.$nextTick(() => {
                    this.$refs.drawerInfo.init(id)
                })
            },
            sortChangeHandle(sort){
                //TODO 传参
                console.log(sort.prop)
                console.log(sort.order)
            },
            assignRoleHandle() {
                if (this.dataListSelections.length > 1) {
                    this.$message.info('只能选择一条记录')
                    return
                }
                let id = this.dataListSelections[0].id
                let ids = this.dataListSelections[0].roleList.map(item => {
                    return item.roleId
                })
                this.assignRoleInfoVisible = true
                this.$nextTick(() => {
                    this.$refs.assignRoleInfo.init(id, ids)
                })
            },
            assignPositionHandle() {
                if (this.dataListSelections.length > 1) {
                    this.$message.info('只能选择一条记录')
                    return
                }
                let id = this.dataListSelections[0].id
                let ids = this.dataListSelections[0].positionList.map(item => {
                    return item.positionId
                })
                this.assignPositionInfoVisible = true
                this.$nextTick(() => {
                    this.$refs.assignPositionInfo.init(id, ids)
                })
            },
            assignOrgHandle() {
                if (this.dataListSelections.length > 1) {
                    this.$message.info('只能选择一条记录')
                    return
                }
                let id = this.dataListSelections[0].id
                let ids = this.dataListSelections[0].orgList.map(item => {
                    return item.orgId
                })
                this.assignOrgInfoVisible = true
                this.$nextTick(() => {
                    this.$refs.assignOrgInfo.init(id, ids)
                })
            },

            initPasswordHandle(id) {
                this.userId = id
                this.dialogFormVisible = true
            },
            dataFormSubmit() {
                this.$refs['temp'].validate((valid) => {
                    if (valid) {
                        updatePassword(
                            {
                                'id': this.userId,
                                'password': this.temp.newPassword
                            }
                        ).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList()
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.dialogFormVisible = false
                        })
                    }
                })
            },
            // 删除
            deleteHandle(id) {
                let ids = id ? [id] : this.dataListSelections.map(item => {
                    return item.id
                })
                this.$confirm(`确定进行${id ? '删除' : '批量删除'}操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteUser(ids).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>

<style lang="scss">
    .el-popover {
        min-width: 100px;
    }

    .user-settings {
        .el-tag{
            margin-right: 5px;
        }
        .el-descriptions{
           .el-tag{
               margin-bottom: 5px;
           }
        }
        .cell{
            text-overflow: clip;
        }
        .col-popover-tip .cell {
            white-space: nowrap;
        }

        .table-cell-p {
            margin: 0;
        }
        .el-dialog__body{
            .password-dialog-form{
                width: 95%;
            }
        }
        .el-transfer-panel{
            width: 330px !important;
        }
        .el-transfer-panel >.el-transfer-panel__body{
            height: 300px !important;
        }
        .el-transfer-panel >.el-transfer-panel__body > .el-transfer-panel__list{
            height: 300px !important;
        }
    }
</style>
